import { GlobalBanner } from 'types/studio/banner';

type BannerCountries = Pick<GlobalBanner, 'countries'>;

export const shouldShowForCountry = (
  banner: BannerCountries,
  userCountry?: string | null
): boolean => {
  // If no countries specified or includes 'Global', show everywhere
  if (!banner.countries?.length || banner.countries.includes('Global')) {
    return true;
  }

  // If no cloudfront location data, don't show banner
  if (!userCountry) {
    return false;
  }

  // Check if user's country matches any of the banner's targeted countries
  return banner.countries.includes(userCountry);
};
